import { createEntityActions } from '@aston/foundation';
import { createAction } from '@ngrx/store';
import { IContactForm } from 'apps/console/src/app/shared-module/models';
const ActionPrefix = 'ContactForm';

export const FormActions = createEntityActions<IContactForm>(ActionPrefix, 'Form');
export const {
	CreateEntityRequest: SubmitFormRequest,
	CreateEntitySuccess: SubmitFormSuccess,
	CreateEntityFailure: SubmitFormFailure
} = FormActions;


export const ToggleForm = createAction(`[${ActionPrefix}] Toggle Form`);
